export default "https://cdn-static.gokick.com/assets/4894ba43e4289cab16e653fbabc6637092de6282/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";